import React from 'react';
import HarbourIcon from './HarbourIcon';
import './harbour.css';

/*
 * Harbour/Icon button: Outlined (48px, white with a control stroke) for close
 * and scroll controls on cards and flyouts; Ghost (44px, no surface) for
 * dismiss actions inside toasts and panels. Icon-only, so a label is required.
 */
export default function HarbourIconButton({ icon, label, kind = 'outlined', className = '', ...rest }) {
  return (
    <button
      type="button"
      aria-label={label}
      className={`harbour-icon-btn ${kind === 'ghost' ? 'harbour-icon-btn--ghost' : ''} ${className}`.trim()}
      {...rest}
    >
      <HarbourIcon name={icon} size={20} />
    </button>
  );
}
